// page.tsx
"use client";

import { useState, Suspense, lazy } from "react";
import LockScreen from "../../Components/Lockscreen";
import "./Buckingham.css";

import { BuckinghamMail } from "./BuckinghamAssets/BuckinghamMailContent";
// import { BuckinghamNoteContent } from "./BuckinghamAssets/BuckinghamNoteContent";
import { BuckinghamMessageContent } from "./BuckinghamAssets/BuckinghamMessagesContent";
import { BuckinghamCallContent } from "./BuckinghamAssets/BuckinghamCallContent";
import { Chat_content } from "../../Components/MessageApp/MessagesInterfaces";
import { BuckinghamTweetContent } from "./BuckinghamAssets/BuckinghamTweeterContent";
import CallApp from "../../Components/CallApp/CallApp";
import { ActivistPhotoContent } from "./BuckinghamAssets/BuckinghamPhotoContent";
import HomeIcon from "../../Components/Icons/HomeIcon";
import TheGramApp from "../../Components/TheGramApp/TheGramApp";
import { BuckinghamTheGramContent } from "./BuckinghamAssets/BuckinghamGramContent";

const Messages = lazy(() => import("../../Components/MessageApp/Messages"));
const Photos = lazy(() => import("../../Components/PhotosApp/Photos"));
const AppsMenu = lazy(
  () => import("../../Components/AppsMenu/AppsMenuBuckingham")
);
const NotesApp = lazy(() => import("../../Components/NotesApp/NotesApp"));
const TweeterApp = lazy(() => import("../../Components/TweeterApp/TweeterApp"));
const InternetApp = lazy(
  () =>
    import("../../Components/InternetApps/WhiteHouseInternetApp/InternetApp")
);
const MailApp = lazy(() => import("../../Components/MailApp/MailApp"));

function Buckingham() {
  const [isLocked, setIsLocked] = useState(true);
  const [activeApp, setActiveApp] = useState("appsmenu");
  const [messages, setMessages] = useState(BuckinghamMessageContent);
  const [messageNotifications, setMessageNotifications] = useState(0);

  const unlock = () => {
    setIsLocked(false);
  };

  const handleStateChange = (chat: Chat_content) => {
    const chatIndex = messages.findIndex(
      (message) => message.name === chat.name
    );
    const previousMessage = messages[chatIndex];
    if (previousMessage && !previousMessage.read) {
      const newMessages = [...messages];
      newMessages[chatIndex] = {
        ...newMessages[chatIndex],
        read: true,
      };
      setMessages(newMessages);
      setMessageNotifications(messageNotifications - 1);
    }
  };

  const renderApp = () => {
    switch (activeApp) {
      case "messages":
        return (
          <Messages
            influencerMessageContent={messages}
            theGram={false}
            handleStateChange={handleStateChange}
          />
        );
      case "phone":
        return <CallApp callContent={BuckinghamCallContent} />;
      case "photos":
        return <Photos albums={ActivistPhotoContent} />;
      // case "notes":
      //   return <NotesApp noteContent={} />;
      case "appsmenu":
        return (
          <AppsMenu
            isLocked={isLocked}
            setActiveApp={setActiveApp}
            messageNotifications={messageNotifications}
          />
        );
      case "tweeter":
        return <TweeterApp tweeterContent={BuckinghamTweetContent} />;
      case "mail":
        return <MailApp emails={BuckinghamMail} />;
      case "thegram":
        return (
          <TheGramApp content={BuckinghamTheGramContent} notifications={0} />
        );

      // case "internet":
      //   return (
      //     <InternetApp
      //       headerImage={InternetBanner}
      //       bodyImage={InternetArtical}
      //       logoIcon={InternetLogo}
      //       searchBarText="Hasina Jafari Mwanga"
      //       articleTitle="Hasina Jafari Mwanga"
      //       articleDate=""
      //       author="President of Tanzania"
      //       photoCaption="via Betty images"
      //       bodyText="President of Tanzania"
      //       website=""
      //     />
      //   );
      default:
        return null;
    }
  };

  return (
    <div className="Mystery">
      <div className="phone-wrapper">
        <div className={`Buckinghamscreen ${activeApp}`}>
          {isLocked ? (
            <div
              className={`lockscreen-container ${
                isLocked ? "visible" : "hidden"
              }`}
            >
              <LockScreen unlock={unlock} password="433351" />
            </div>
          ) : null}

          <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                Loading...
              </div>
            }
          >
            {renderApp()}
          </Suspense>
          <div className="home-button-container">
            <HomeIcon onClick={() => setActiveApp("appsmenu")} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Buckingham;
